import { useState } from 'react'

const CustomValuesHook = (props) => {
    const [state, setState] = useState({...props})

    const handleChange = (e )=> {
        for(let prop in e){
            setState((state) => ({
            ...state,
            [prop]: e[prop]
        }))
        }
        
    }

    const handleResetState=()=>{
        setState({...props})
    }
    return [state, handleChange,handleResetState];
}

export default CustomValuesHook;